import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SelectAutocomplete from '../../../../common/components/select-autocomplete';
import IReportsFiltersModel from '../interfaces/IReportsFiltersModel';
import IReportsFiltersProps from './interfaces/IReportsFiltersProps';
import ReportsGenerate from '../reports-generate/reports-generate';
import RangePicker from '../../../../common/components/range-picker';
import './reports-filters.scss';
import { isNotEmpty } from '../../../../utils/string-utils';
import { getLoadChannelOptions } from '../../../../common/enums/loads/load-channel-types.enum';

export interface SelectOption {
    label: string;
    value: string;
}

function ReportsFilters({
    isGeneratingReport,
    setIsGeneratingReport,
}: Readonly<IReportsFiltersProps>) {
    const { t } = useTranslation();
    const [filterValues, setFilterValues] = useState<
        Partial<IReportsFiltersModel>
    >({
        channel: getLoadChannelOptions(true)[0],
    });
    const [filterErrorValues, setFilterErrorValues] =
        useState<Partial<IReportsFiltersModel>>();

    const getSelectOptionsReports = (): SelectOption[] => {
        return [{ label: t('TypeRelatorios'), value: 'LoadsReport' }];
    };

    return (
        <div className="reports-filters-container">
            <div className="reports-filters__left-side">
                <div className="reports-filter__reports">
                    <SelectAutocomplete
                        label={t('Relatorios')}
                        value={filterValues?.reportType}
                        onChange={(e: any) => {
                            setFilterValues({ ...filterValues, reportType: e });
                        }}
                        placeholder={t('SelecioneRelatorio')}
                        dataTestId="reports-filters_type"
                        options={getSelectOptionsReports()}
                        helperText={filterErrorValues?.reportType}
                        error={isNotEmpty(filterErrorValues?.reportType)}
                    />
                </div>

                <RangePicker
                    startDateLabel={t('DataInicio')}
                    startDate={filterValues?.startDate}
                    startDateError={filterErrorValues?.startDate}
                    onChangeStartDate={(value: any) => {
                        setFilterValues({ ...filterValues, startDate: value });
                    }}
                    endDateLabel={t('DataFim')}
                    endDate={filterValues?.endDate}
                    endDateNote={t('RelatorioDataFimNota')}
                    endDateError={filterErrorValues?.endDate}
                    onChangeEndDate={(value: any) => {
                        setFilterValues({ ...filterValues, endDate: value });
                    }}
                    canChooseSameDate
                    daysRangeLimit={31}
                />

                <div className="reports-filter__reports">
                    <SelectAutocomplete
                        id="load-channel-filter"
                        label={t('Canal')}
                        defaultValue={filterValues.channel}
                        value={filterValues.channel}
                        onChange={(e: any) => {
                            setFilterValues({ ...filterValues, channel: e });
                        }}
                        placeholder={t('Selecionar')}
                        options={getLoadChannelOptions(true)}
                        data-testid="report-filters__channel"
                    />
                </div>
            </div>
            <div className="reports-filters_right-side">
                <ReportsGenerate
                    reportType={filterValues?.reportType ?? ''}
                    startDateFilter={filterValues?.startDate ?? ''}
                    endDateFilter={filterValues?.endDate ?? ''}
                    channel={filterValues?.channel ?? ''}
                    isGeneratingReport={isGeneratingReport}
                    setIsGeneratingReport={setIsGeneratingReport}
                    setFilterErrorValues={setFilterErrorValues}
                />
            </div>
        </div>
    );
}

export default ReportsFilters;
